import { AuthApi } from '../apis';
import { auth } from '../firebase';
export async function logout(store: any, router: any, redirectLogin: boolean = true) {
  try {
    await auth.signOut();
    await new AuthApi().logOut();
    window.sessionStorage.clear();
    window.localStorage.clear();
    if (redirectLogin) {
      router.push({ name: 'login' });
    }
  } catch (error) {
    console.error('Logout failed:', error);
  }
}
